'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import React, { useEffect } from 'react';
import { Alert } from 'reactstrap';
import { MdCheckCircle } from 'react-icons/md';
import { getI18nUtils } from '../../i18n/i18n-utils';
import { Dictionaries } from '../../i18n/i18n-config';

function JobsearchSavedAlert({
  isOpen,
  toggle,
  dictionary,
}: {
  isOpen: boolean;
  toggle: () => void;
  dictionary: Partial<Dictionaries>;
}) {
  const { formatMessage } = getI18nUtils(dictionary);

  useEffect(() => {
    // make the alert close after 3 seconds
    if (!isOpen) return;
    const timer = setTimeout(toggle, 3000);
    return () => clearTimeout(timer);
  }, [isOpen]);

  return (
    <Alert
      isOpen={isOpen}
      toggle={toggle}
      id="jobsearch-saved-alert"
      type="success"
      className="d-flex justify-content-start align-items-center mt-3 border-bottom"
    >
      <MdCheckCircle size={22} className="me-3" />
      <div className="me-auto">
        <span className="d-block fw-bold mb-1">{formatMessage({ id: 'saved_jobsearch' })}</span>
        <span className="d-block">{formatMessage({ id: 'save_jobsearch_success' })}</span>
      </div>
    </Alert>
  );
}

export default JobsearchSavedAlert;
